var couchFnReduce = function(queryData) {
  const data = queryData.rows
  let calibracoes
  let res = data.reduce((a, c) => {
    if (c.key[1] === 0) {
      a.inst = c.value
      calibracoes = c.value.calibracoes
      //delete a.inst.calibracoes
    }
    if (c.key[1] === 1) {
      a.config.push(c.value)
    }
    if (c.key[1] === 2) {
      a.ocorr.push(c.value)
    }
    return a
    
  }, {inst: undefined, config: [], ocorr: []})
  
  
  let historico = []
  res.seriesDenormRes = calibracoes.reduce((a, cal) => {
    let calObj = {}
    Object.keys(cal)
      .filter((k) => k !== 'Faixas')
      .map((k) => calObj[k] = cal[k])

    for (let i = 0; i < cal.Faixas.length; i++) {
      let faixa = cal.Faixas[i]
      let faixaObj = Object.assign({}, calObj)

      Object.keys(faixa)
        .filter((k) => k !== 'series')
        .map((k) => faixaObj[k] = faixa[k])

      for (let j = 0; j < faixa.series.length; j++) {
        let serie = faixa.series[j]
        let serieObj = Object.assign({}, faixaObj)
        Object.keys(serie)
          .map((k) => {
            if (k === 'nome') {
              serieObj['nomeSerie'] = serie[k]
              return
            }
            serieObj[k] = serie[k]
          })

        
        // registra os pontos para que posteriormente 
        // possamos obter o histórico
        for (let l = 0; l < serie.data.Valor.length; l++) {
          let valor = serie.data.Valor[l]
          let historicoPonto = Object.keys(serie.data)
            .reduce((a, c) => {
              a[c] = serie.data[c][l]
              return a
            }, {})
          
          historicoPonto.HoraInicial = cal.HoraInicial
          historicoPonto.cod = serie.cod
          historicoPonto.nomeSerie = serie.nome
          historicoPonto.CodigoFaixaModelo = faixa.CodigoFaixaModelo

          historico.push(historicoPonto)

        }
        
        a.push(serieObj)
      }
    }
    return a

  }, [])

  for (let i = res.seriesDenormRes.length - 1; i >= 0; i--) {
    let item = res.seriesDenormRes[i]
    
    item.historicosPontos = historico.filter((x) => {
      return x.cod === item.cod &&
      x.CodigoFaixaModelo === item.CodigoFaixaModelo
    })

  }
  return res
}

export {couchFnReduce}